import { dmApi } from "../../../app/dmApi";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../../helpers/RtkQueryUtils";
import { serialize } from "../../../helpers/Utils";

export const humidApi = dmApi.injectEndpoints({
    endpoints: (build) => ({

        getHumidSortingRecord: build.query({
            query: (data) => {
                const paramData = serialize(data);
                return {
                    url: `/rework/humidity/sorting-record?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['humidSorting'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        getHumidSummary: build.query({
            query: (data) => {
                const paramData = serialize(data);
                return {
                    url: `/rework/humidity/summary?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['humidSummary'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        createHumidSortingData: build.mutation({
            query: (requestBody) => ({
                url: `/rework/humidity/sorting-create`,
                method: 'POST',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['humidSorting','humidSummary'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Data");
            },
        }),

        updateHumidSortingData: build.mutation({
            query: ({ id, requestBody }) => ({
                url: `/rework/humidity/sorting-update/${id}`,
                method: 'PUT',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['humidSorting','humidSummary'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Data");
            },
        }),

        createHumidOvenData: build.mutation({
            query: (requestBody) => ({
                url: `/rework/humidity/ovens-data/create`,
                method: 'POST',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['humidOvenData','humidSummary','ovenList','cartList'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Data");
            },
        }),

        updateHumidOvenData: build.mutation({
            query: ({ id, requestBody }) => ({
                url: `/rework/humidity/ovens-data/update/${id}`,
                method: 'PUT',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['humidOvenData','humidSummary','ovenList','cartList'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Data");
            },
        }),

        searchHumidOvenData: build.query({
            query: (data) => {
                const paramData = serialize(data);
                return {
                    url: `/rework/humidity/ovens-data/logs?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['humidOvenData'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        searchHumidLogs: build.query({
            query: (data) => {
                const paramData = serialize(data);
                return {
                    url: `/rework/humidity/logs?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['humidLogs'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        updateHumidLog: build.mutation({
            query: ({ id, requestBody }) => ({
                url: `/rework/humidity/logs/update/${id}`,
                method: 'PUT',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['humidLogs','humidSummary'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Data");
            },
        }),

    }),
});

export const {
    useGetHumidSortingRecordQuery,
    useGetHumidSummaryQuery,
    useCreateHumidSortingDataMutation,
    useUpdateHumidSortingDataMutation,
    useCreateHumidOvenDataMutation,
    useUpdateHumidOvenDataMutation,
    useSearchHumidOvenDataQuery,
    useSearchHumidLogsQuery,
    useUpdateHumidLogMutation,
} = humidApi;
